// API Configuration
import appConfig from './appConfig';

const API_CONFIG = {
  // Base URL for all API endpoints
  // Priority: 1. In production, always use production URL (ignore env vars)
  //           2. In development, use REACT_APP_API_BASE_URL if set, otherwise localhost
  BASE_URL: (() => {
    // In production, always use production URL (ignore any env vars that might point to localhost)
    //return 'https://unividya.org/edubridge';
    /*if (process.env.NODE_ENV === 'development') {
      return 'http://127.0.0.1:8000';
    }*/
    // In development mode
    // If REACT_APP_API_BASE_URL is explicitly set, use it (allows override for testing)
    if (process.env.REACT_APP_API_BASE_URL) {
      return process.env.REACT_APP_API_BASE_URL;
    }
    return 'https://unividya.org/edubridge';
  })(),
  
  // API Keys
  KEYS: {
    UNIVERSITY_KEY: process.env.REACT_APP_UNIVERSITY_KEY || appConfig.university.publicKey,
    // Add more API keys as needed
    // LMS_KEY: process.env.REACT_APP_LMS_KEY || 'your-lms-key',
    // PAYMENT_KEY: process.env.REACT_APP_PAYMENT_KEY || 'your-payment-key',
  },
  
  // API Endpoints
  ENDPOINTS: {
    STUDENT_LOGIN: '/api/student/login',
    STUDENT_REGISTER: '/api/student/register',
    STUDENT_PROFILE: '/api/student/profile',
    STUDENT_STEP1: '/api/students/step1',
    APPLICATION_SUBMIT: '/api/application/submit',
    APPLICATION_STATUS: '/api/application/status',
    COURSE_FEES: '/api/students/course-fees',
    UNIVERSITY_COURSES: '/api/university/leads/university-courses',
    SPECIALIZATIONS: '/api/leads/specializations',
    LEAD_SUBMISSION: '/api/university/leads',
    STATES: '/api/locations/states',
    DISTRICTS: '/api/locations/districts',
    // Add more endpoints as needed
    // LMS_LOGIN: '/api/lms/login',
    // PAYMENT_PROCESS: '/api/payment/process',
  },
  
  // Request timeout (in milliseconds)
  TIMEOUT: appConfig.api.timeout,
  
  // Default headers
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  }
};

export default API_CONFIG;
